import { CognitoUser } from 'amazon-cognito-identity-js';
import { AuthStage } from '.';

interface Params {
  user: CognitoUser;
  setAuthStage: (stage: AuthStage) => void;
}

export default function onForgotPassword(params: Params): void {
  const { user, setAuthStage } = params;

  const onSuccess = (): void => {
    setAuthStage(AuthStage.FORGOT_SENT);
  };

  const onFailure = (err: Error): void => {
    // eslint-disable-next-line no-console
    console.error('forgot password failed', err);
    setAuthStage(AuthStage.FORGOT_SENT);
  };

  user?.forgotPassword({ onSuccess, onFailure });
}
